import React, { Component } from 'react';
// import ShipmentModel from '../../models/shipment.model'
// import shipmentDataPlaneModel from '../../models/shipment.plane.model'
// import AddComment from './components/add-comment'
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
// import RestService from '../../../../../../services/restService'
import Table from './../Table'
import { Card, CardBody } from 'reactstrap';
import axios from 'axios';
import './styles.scss'

import Download from './components/Download';


// const rest = new RestService()

class Tracking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      shipment: "",
      shipmentDataPlane: "",
      comments: [],
      disabledView: false,
      disabledDownload: false,
      data: [],
      load: false,
      columns:
        [
          { label: 'Document Name', key: 'Name' },
          { label: 'Document Type', key: 'Type' },
          // { label: 'Categoría', key: 'Category' },
          { label: 'Creation Date', key: 'CreationDate' },
          { label: 'Updated By', key: 'CreateBy' },
          {
            label: 'Download', key: 'URL', custom: (value) => {
              return (
                <Download file={value.URL} type={value.Type} name={value.Name} action='download' />
              )
            }
          },
          {
            label: 'View', key: 'DocumentKeyAsString', custom: (value) => {
              return (
                <Download file={value.URL} type={value.Type} name={value.Name} action='visualization' />
              )
            }
          },
        ],
    };
  }


  componentDidMount = () => {
    this.setState({
      data: this.props.dataDoc ? this.props.dataDoc : [],
      shipment: this.props.shipment,
      shipmentDataPlane: this.props.shipmentDataPlane
    }, () => {
      // this.getComments()
    })
  }


  componentWillReceiveProps = (nextProps) => {
    console.log("nextProps", nextProps);

    this.setState({
      data: nextProps.dataDoc ? nextProps.dataDoc : [],
      shipment: nextProps.shipment,
      shipmentDataPlane: nextProps.shipmentDataPlane
    })
  }

  getComments = () => {
    let { shipment } = this.state
    let id = shipment.id;
    // let id = 7328908;
    // axios.get(`http://192.168.1.73:3017/documents/findDocumentsWPS/${id}`)
    axios.get(`https://poseidonbooking.azurewebsites.net/documents/findDocumentsWPS/${id}`)
      .then((response) => {
        this.setState({ data: response.data.data });
        this.getCommentsView();
      }).catch((error) => {
        console.log('response', error.response);
      });
  }

  getCommentsView = () => {
    let { shipmentDataPlane } = this.state
    let id = shipmentDataPlane.ShipmentId;
    // let id = 122;
    let moduleId = 3;
    // axios.get(`http://192.168.1.73:3017/documents/findDocumentsView/${moduleId}/${id}`)
    let url = `https://poseidonbooking.azurewebsites.net/documents/findDocumentsView/${moduleId}/${id}`;
    axios.get(url)
      .then((response) => {
        let newData = this.state.data;
        let viewData = response.data.data;
        viewData.map((e) => {
          newData.push(e);
          return e;
        })
        this.setState({ data: newData });
      }).catch((error) => {
        console.log('response', error.response);
      });
  }

  toggle = evt => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  callback = (success) => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }), () => this.getComments());
  }

  onError = (error) => {
    console.log(error)
    this.setState(prevState => ({
      modal: !prevState.modal
    }), () => this.getComments());
  }

  // viewDocument = (id, download) => {
  //   console.log('id, download', id, download);

  //   if (download) {
  //     this.setState({ disabledDownload: true });
  //   }
  //   else {
  //     // document.getElementById('jaja').className = "big spinner loading icon";
  //     this.setState({
  //       disabledView: true,
  //     });
  //   }
  //   let idContainer = id.URL;
  //   console.log('idContainer', idContainer);

  //   var options = {
  //     responseType: 'arraybuffer',
  //     headers: {
  //       'Content-Type': 'application/json'
  //     }
  //   };
  //   var type = 'application/pdf';
  //   // let url = `${Services.Get_DowloadDocument.Path}document/downloadFile/${5}`;
  //   let url = `https://rrapidocuments.azurewebsites.net/documents/downloadFile/${idContainer}`;
  //   options = {};

  //   var view = '';
  //   axios.get(url, options)
  //     .then(response => {
  //       // console.log("Response----->", response.data);
  //       var name = id.Name;
  //       var dataView;

  //       var base64str = response.data.data;
  //       dataView = response.data.data;
  //       var binary = atob(base64str.replace(/\s/g, ''));
  //       var len = binary.length;
  //       var buffer = new ArrayBuffer(len);
  //       view = new Uint8Array(buffer);
  //       for (var i = 0; i < len; i++) {
  //         view[i] = binary.charCodeAt(i);
  //       }

  //       var blob = new Blob([view], { type: type });
  //       var url = URL.createObjectURL(blob);
  //       var hiddenElement = document.createElement('a');
  //       hiddenElement.href = url;
  //       hiddenElement.setAttribute('href', url);
  //       hiddenElement.style.visibility = 'hidden';

  //       if (download) {
  //         hiddenElement.download = name;
  //         hiddenElement.setAttribute('download', name);
  //         document.body.appendChild(hiddenElement);
  //         hiddenElement.click();
  //         document.body.removeChild(hiddenElement);
  //         this.setState({ disabledDownload: false });
  //       } else {
  //         if (id.CreateBy === 'WPS') {
  //           hiddenElement.target = '_blank';
  //           hiddenElement.setAttribute('target', '_blank');
  //           var winlogicalname = name;
  //           var winparams = 'dependent=yes,locationbar=no,scrollbars=yes,menubar=yes,' +
  //             'resizable,screenX=50,screenY=50,width=850,height=1050';
  //           var htmlText = '<embed width=100% height=100%'
  //             + ' type="application/pdf"'
  //             + ' src="data:' + type + ';base64,'
  //             + escape(dataView)
  //             + '"></embed>';
  //           // Open PDF in new browser window
  //           var detailWindow = window.open('', winlogicalname, winparams);
  //           detailWindow.document.write(htmlText);
  //           detailWindow.document.close();
  //           this.setState({ disabledView: false });
  //         }
  //         else {
  //           window.open('https://fsposeidon.blob.core.windows.net/magicrrvision/' + id.URL);
  //         }
  //       }

  //     }).catch(error => {
  //       console.error('response ->:', error);
  //     });
  // }

  render() {
    return (
      <>
        <Card className="myCard">
          <CardBody>
            <div className="row">
              <div className="col-12">
                <Table
                  columns={this.state.columns}
                  data={this.state.data}
                  itemsByPage={10}
                  options={{
                    large: false,
                    downloads: {
                      pdf: false,
                      xlsx: false
                    },
                    pagination: true,
                    search: true,
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-11">
              </div>
              {/* <div className="col-1">
                    <Fab color="primary" size="small" aria-label="add" onClick={this.toggle}>
                      <AddIcon />
                    </Fab>
                  </div> */}

            </div>
          </CardBody>
        </Card>
        <Modal isOpen={this.state.modal} toggle={this.toggle} >
          <ModalHeader toggle={this.toggle}>Create new document</ModalHeader>
          <ModalBody>
            {/* <AddComment callback={this.callback} onError={this.onError} shipmentDataPlane={this.state.shipmentDataPlane} /> */}
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default Tracking;
